import { DeleteButton, EditButton } from "@/components/IconButton/variants";
import PropTypes from "prop-types";
import React from "react";

function Actions({
  row,
  handleOnClickDelete = false,
  handleOnClickEdit = false,
}) {
  return (
    <div className="w-auto flex gap-x-1 justify-center">
      {handleOnClickEdit && (
        <EditButton onClick={() => handleOnClickEdit(row.original)} />
      )}
      {handleOnClickDelete && (
        <DeleteButton onClick={() => handleOnClickDelete(row.original)} />
      )}
    </div>
  );
}

Actions.propTypes = {
  row: PropTypes.object.isRequired,
  handleOnClickDelete: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  handleOnClickEdit: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
};

export default React.memo(Actions);
